import React from "react";
import { Link } from "react-router-dom";

/**
 * RD-0731 — compact legal links for RivieraDeploy surfaces (landing + dashboard).
 */
function DeployLegalFooter({ className = "" }) {
  return (
    <footer className={`text-xs text-gray-600 border-t border-gray-800 pt-6 ${className}`}>
      <div className="flex flex-wrap gap-x-4 gap-y-2 justify-center md:justify-start">
        <Link to="/limelite/deploy/terms" className="hover:text-silver-light underline underline-offset-2">
          Terms
        </Link>
        <Link to="/limelite/deploy/limitations" className="hover:text-silver-light underline underline-offset-2">
          Limitations
        </Link>
        <Link to="/limelite/deploy/abuse-report" className="hover:text-silver-light underline underline-offset-2">
          Abuse &amp; DMCA
        </Link>
        <a href="/api/deploy/status/public" className="hover:text-silver-light underline underline-offset-2" target="_blank" rel="noopener noreferrer">
          Status
        </a>
      </div>
      <p className="mt-3 text-center md:text-left text-gray-700 max-w-2xl">
        We may suspend or terminate service for abuse or non-payment. Reports are triaged as soon as practicable (24h target on
        business days). Billing in EUR.
      </p>
    </footer>
  );
}

export default DeployLegalFooter;
